// Styles
import { blue, green, grey, orange, red } from '../../../common/styles/colours';
export var BadgeStylePropertiesByVariant = {
    neutral: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundOverlay) !== null && _a !== void 0 ? _a : grey[200],
            contentColor: (_b = theme.contentPrimary) !== null && _b !== void 0 ? _b : grey[900],
        });
    },
    warning: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundWarningSecondary) !== null && _a !== void 0 ? _a : orange[100],
            contentColor: (_b = theme.contentWarningOnColor) !== null && _b !== void 0 ? _b : orange[900],
        });
    },
    positive: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundPositiveSecondary) !== null && _a !== void 0 ? _a : green[100],
            contentColor: (_b = theme.contentPositiveOnColor) !== null && _b !== void 0 ? _b : green[900],
        });
    },
    negative: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundNegativeSecondary) !== null && _a !== void 0 ? _a : red[100],
            contentColor: (_b = theme.contentNegativeOnColor) !== null && _b !== void 0 ? _b : red[900],
        });
    },
    info: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundAccentSecondary) !== null && _a !== void 0 ? _a : blue[200],
            contentColor: (_b = theme.contentAccentOnColor) !== null && _b !== void 0 ? _b : blue[900],
        });
    },
    subtle: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundOverlay) !== null && _a !== void 0 ? _a : grey[900],
            contentColor: (_b = theme.contentTertiary) !== null && _b !== void 0 ? _b : grey[600],
        });
    },
    backgroundNegative: function (theme) {
        var _a, _b;
        return ({
            backgroundColor: (_a = theme.backgroundNegative) !== null && _a !== void 0 ? _a : red[500],
            contentColor: (_b = theme.contentOnColor) !== null && _b !== void 0 ? _b : grey[0],
        });
    },
};
//# sourceMappingURL=BadgeStylePropertiesByVariant.js.map